import "../CSS/Vcdeviceregistation.css";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { FaEye } from "react-icons/fa";
// import {useTable,  useBlockLayout, useResizeColumns, usePagination, useSortBy, useFilters}  from 'react-table';
import { getAPIHostURL } from "../../ClientConfig";
// import { FaSearch, FaEdit, FaEye, FaUserPlus } from 'react-icons/fa';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { trimStringAndRemoveTrailingComma } from "../../vtUtil";
import { AppRelevantDataContext } from "../../AppContext";
import VcOrder from "./VcOrder";
import DateTimePicker from "react-datetime-picker";
import {
  IDS_LoginServerIssue,
  IDS_RegistNetworkError,
  IDS_AUSrvrIssueReqParamsNotSent,
  IDS_AUSrvrIssueReqParamsNotSentForSubsInfo,
} from "../../VcLanguage";
// import { Pagination, Select } from 'antd';
// import { FaArrowDownLong, FaArrowUpLong } from 'react-icons/fa6';
import { FaQrcode, FaTimes } from "react-icons/fa";
import { ITM_STATE_DEMO, ITM_STATE_SOLD, ITM_STATE_RENTAL} from '../../VcConstants';
import { QrScanner } from "@yudiel/react-qr-scanner";

// const validEmailRegex = RegExp(/^(([a-z0-9]+(\.[a-z0-9]+)*))@((([a-z0-9]+(\-*[[a-z0-9]+)*))+(\.[a-z]{2,})+)$/i);
const validEmailRegex = RegExp(
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
);
const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val > 0 && (valid = false));
  return valid;
};

function VcDeviceRegistration(props) {
  const context = useContext(AppRelevantDataContext);

  const [state, setState] = useState({
    email: "",
    isEmailVerified : false,
    showRegisterSummaryBox: false,
    createButtonClicked: "",
    failedDevices: {},
    vicinityTypes: [],
    roomTypes :[],
    deviceID: "",
    deviceName: "",
    pinCode: "",
    groupedErrors: {},
    toiletSeats:"",
    toiletSection:"",
    roomType: "",
    tankheight:"",
    volumeLitres: "",
    defineOrSelectExistingToilet: "",
    isDeviceInstalled: false,
    existingToiletName: "",
    newToiletName :"",
    firststdeviceidmodel: 0,
    searchedDevicesArr: [],
    deviceType:"",
    arrDeviceList: [],
    authTypesFromBackend: [],
    arrExistingToiletList:[],
    newlyAddedToiletNodeID: "",

    devcIDQRCodeFlag: false,
    retrivedDeviceType : "",


    errors: {
      email: "",
      errors:"",
      deviceExistenceErr: "",
      deviceID:"",
      arrDeviceList: "", 
      deviceName: "",
      pinCode: "",
      roomType: "",
      toiletSection:"",
      toiletSeats:"",
      createButtonClicked: "",
      tankheight:"",
      authTypesFromBackend: [],
      volumeLitres: "",
      defineOrSelectExistingToilet: "",
      existingToiletName: "",
      newToiletName : "",
      newlyAddedToiletNodeID: "",
      others: "",
      noDeviceFoundErr: "",
    },
  });
  const [deviceList, setDeviceList] = useState([]);
  const [deviceTypeFromBackend, setDeviceTypeFromBackend] = useState("");
  const [showFailedDeviceModal, setShowFailedDeviceModal] = useState(false);
  const [selectedFailedGroup, setSelectedFailedGroup] = useState(null);
 
  const { errors } = state;
  let appRelevantDataContextValue = context; 
  let t = appRelevantDataContextValue.t;

  const onChangedeviceID = (e) => {
    const value = e.target.value;
    setState((prev) => ({
      ...prev,
      deviceID: e.target.value,
      devcIDQRCodeFlag: false,
      errors: {
        ...prev.errors,
        deviceID: "",
        deviceExistenceErr: "",
        arrDeviceList: "",
        others: ""
      },
    }));
  };

  const verifyEmail=(e)=>{
    e.preventDefault();
    let modifiedState = { ...state };
    modifiedState.errors.email = "";
    modifiedState.errors.others = "";

    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t;
    if (!modifiedState.email || modifiedState.email.trim().length === 0) {
      modifiedState.errors.email = "Email ID is required";
      setState(modifiedState);
      return;
    }
    if (!validEmailRegex.test(modifiedState.email)) {
      modifiedState.errors.email = "Enter a valid Email ID";
      setState(modifiedState);
      return;
    }
    const jsonParams = {
      email: modifiedState.email.toLowerCase(), 

    };
    axios.post(`${getAPIHostURL()}/wclient/verifyEmailForRegisteringDevice`, jsonParams)
    .then(response => {
      if(response.data.code == 'SUCCESS') {

        if (response.data.retrivedLatestTreeNodeID == null ||response.data.retrivedLatestTreeNodeID.length <= 0) {
          modifiedState.errors.others = "Email verification failed. Email not found.";
          modifiedState.isEmailVerified = false;
        } else {
          // Checks if we get the backend json and if yes then converts it to an array.
            try {
              modifiedState.authTypesFromBackend = JSON.parse(response.data.retrivedLatestTreeNodeID[0].extractedAuthType);
            } catch (e) {
              modifiedState.errors.others = "Email Validation failed.";
              modifiedState.isEmailVerified = false;
            }
            // Defines which login auth type is valid.
            const allowedAuthTypes = ["apple", "google", "smarthhm"];

            // Checks if at least one auth type from backend matches allowed ones.
            const isValid = modifiedState.authTypesFromBackend.some(type =>
              allowedAuthTypes.includes(type.toLowerCase())
            );
            // VERIFIED
            if(response.data.retrivedLatestTreeNodeID[0].extractedAuthType == null || response.data.retrivedLatestTreeNodeID[0].extractedAuthType <= 0 || isValid == false){
              modifiedState.errors.others = "User is not Validated. Please Re-register and validate Email";
              modifiedState.isEmailVerified = false;
            } else{
                modifiedState.isEmailVerified = true;
                modifiedState.isDeviceInstalled = false;
                modifiedState.others = "";
                modifiedState.showRegisterSummaryBox = false;
                modifiedState.failedDevices = [];
                modifiedState.arrDeviceList = [];
                modifiedState.retrivedDeviceType = "";
                modifiedState.deviceID = "";
                modifiedState.deviceName = "";
                modifiedState.pinCode = "";
                modifiedState.defineOrSelectExistingToilet = "";
                modifiedState.arrExistingToiletList = [];
                modifiedState.existingToiletName = "";
                modifiedState.newToiletName = "";
                modifiedState.newlyAddedToiletNodeID = "";
                modifiedState.roomType = "";
                modifiedState.volumeLitres = "";
                modifiedState.tankheight = "";
                modifiedState.toiletSeats = "";
                modifiedState.toiletSection = "";
                
                // ===== Fill room types(vicinity) dropdown from backend =====
                modifiedState.roomTypes = Array.isArray(response.data.VicinityType)
                ? response.data.VicinityType.map(item => item.VicinityType)  // extract VicinityType string from each row
                : [];
                // Optionally, reset selected roomType if you want
            } 
          }
        } else {
          if(response.data.code == "SQL_ERROR") {
          modifiedState.errors.others = "Server experiencing issues.\nTry again later.";  
        } else if(response.data.code == "USER_NOT_REGISTERED") {
          modifiedState.errors.others = response.data.failuremessage;  
        } else {
          console.log("Should not reach here.")
          modifiedState.errors.others = "Server experiencing issues.\nTry again later.";   // TODO: Define generic language error for this
          }
        }   
        setState(modifiedState);  
      }).catch( error => {
        if (axios.isCancel(error)) {
          console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
        } else {
          setState(prev => ({
          ...prev,
          errors: {...prev.errors, others: "Network error. Please try again."
            }
          }));
        }
    });
  }

  const openQRCameraForPrdItmStateDevcID = async () => {
    const result = await navigator.permissions.query({ name: "camera" });

    if (result.state === "denied") {
      alert("Camera permission is blocked. Please enable it.");
      return;
    }

    setState((prev) => ({
      ...prev,
      devcIDQRCodeFlag: !prev.devcIDQRCodeFlag,
      deviceID: "",
      errors: {
        ...prev.errors,
        deviceExistenceErr: "",
      },
    }));
  };

  const handleScanResultOfPrdItmStateDevcID = (data) => {
    if (!data) return;

    setState((prev) => ({
      ...prev,
      deviceID: data,
      devcIDQRCodeFlag: false,
    }));
  };

  const validateDeviceTypeAndState = (e) => {
    e.preventDefault();
    let modifiedState = { ...state };
    modifiedState.errors = {
      ...modifiedState.errors,
      others: "",
      arrDeviceList: "",  
      deviceID: "",
      deviceName: ""
    };

    let appRelevantDataContextValue = context;
    let t = appRelevantDataContextValue.t;

    modifiedState.errors.deviceID = (modifiedState.deviceID == null || modifiedState.deviceID.length <= 0) ? "Please enter Device ID" : "";
    modifiedState.errors.deviceName = (modifiedState.deviceName == null || modifiedState.deviceName.length <= 0) ? "Please enter Device Name" : "";

    if( modifiedState.errors.deviceID || modifiedState.errors.deviceName ) {
      setState(modifiedState);
      return;
    }
    //Prevent duplicate DeviceID BEFORE API call
    if (
      modifiedState.arrDeviceList.some(
        device => device.id === modifiedState.deviceID
      )
    ) {
      alert( `Device ID '${modifiedState.deviceID}' is already added.`);
      return; //stop API call
    }
    let jsonParams = {
      email: modifiedState.email.toLowerCase(), 
      deviceID: modifiedState.deviceID,
      deviceType: modifiedState.retrivedDeviceType || null,
    }
    axios.post(`${getAPIHostURL()}/wclient/validateDeviceTypeAndState`, jsonParams)
    .then(response => {
    if(response.data.code == 'SUCCESS') {
      if( response.data.isDeviceType == null || response.data.isDeviceType.length <= 0) {
        modifiedState.errors.others = `Retrived Device Type for Device ID '${modifiedState.deviceID}' not found`;
      } else {
        if (!modifiedState.retrivedDeviceType) {
            // Getting first device type
            modifiedState.retrivedDeviceType = response.data.isDeviceType;
        }
        // checking device type consistency of the next device to see if it has the same type as the first device.
        if (
          modifiedState.retrivedDeviceType &&
          modifiedState.retrivedDeviceType !== response.data.isDeviceType
        ) {
          modifiedState.errors.others = `Device type mismatch. Expected '${modifiedState.retrivedDeviceType}' but got '${response.data.isDeviceType}'.`;
          setState(modifiedState);
          return;
        }
        // Adding the devices to the list if all the conditions are satisfied.
        if (!modifiedState.arrDeviceList.some(
          device => device.id === modifiedState.deviceID

        )) 
        modifiedState.arrDeviceList = [
        {
          id: modifiedState.deviceID,
          name: modifiedState.deviceName,
        },
        ...modifiedState.arrDeviceList,
      ];

        modifiedState.errors.arrDeviceList = "";
        modifiedState.deviceID = "";
        modifiedState.deviceName = "";
        modifiedState.errors.others = "";
        modifiedState.errors.deviceID = "";
        modifiedState.errors.deviceName = "";

      }

    } else {
      if (response.data.code == 'REQ_PARAMS_MISSING') {
          modifiedState.errors.others = "Server experiencing issues (required parameters not sent). Try again later."; 
      } else if(response.data.code == "SQL_ERROR") {
          modifiedState.errors.others = "Server experiencing issues.\nTry again later.";  
      } else if(response.data.code == "INVALID_DEVICEID") {
          modifiedState.errors.others = response.data.failuremessage;  
      } else if(response.data.code == "DEVICE_CANNOT_BE_REGISTERED"){
          modifiedState.errors.others = response.data.failuremessage;  
      } else if(response.data.code == "DEVICE_TYPE_NOT_MATCH_WITH_EXISTING_DEVICE") {
          modifiedState.errors.others = response.data.failuremessage;  
      } else if(response.data.code == "CURRENT_STATE_IS_INVALID") {
          modifiedState.errors.others = response.data.failuremessage;  
      } else if(response.data.code == "DEVICE_ALREADY_ASSIGNED"){
          modifiedState.errors.others = response.data.failuremessage;
      } else if (response.data.code == "OWNER_IS_DEFAULT_PRESENT"){
          modifiedState.errors.others = response.data.failuremessage;
      } else if (response.data.code == "OWNER_ALREADY_EXISTS"){
          modifiedState.errors.others = response.data.failuremessage;
      } else if(response.data.code == "OWNER_CANNOT_BE_MODIFIED"){
          modifiedState.errors.others = response.data.failuremessage;
      }else if(response.data.code == "DEVICE_NOT_INVALID_CURRENTSTATE_INVALID_EMAIL_INVALID"){
          modifiedState.errors.others = response.data.failuremessage;
      }
      else {
          console.log("Should not reach here.")
          modifiedState.errors.others = "Server experiencing issues.\nTry again later.";   // Define generic language error for this
      }
    }   
    setState(modifiedState);  
    }).catch( error => {

      if (axios.isCancel(error)) {
          console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
      } else {
          setState(prev => ({
          ...prev,
          errors: {...prev.errors, others: "Network error. Please try again."
          }
        }));
      }
    });
  }

  const removeDevice = (deviceIDToRemove) => {
    setState((prev) => {
      const newArr = prev.arrDeviceList.filter(
        (device) => device.id !== deviceIDToRemove
      );
      // If you remove the last device or any device, reset related fields
        return {
          ...prev,
          arrDeviceList: newArr,
          // Only reset these if needed
          deviceID: "",
          deviceName: "",
          retrivedDeviceType: "", 
          errors: {
            ...prev.errors,
            deviceID: "",
            deviceName: "",
            arrDeviceList: "",
            others: "",
          },
        };
    });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    let errors = { ...state.errors };
    switch (name) {
      case "email":
      // Reset errors when user types
      setState((prev) => ({
        ...prev,
        email: value,
        // hide the section other than email
        isEmailVerified: false,  
        errors: {
          ...prev.errors,
          email: "",
          arrDeviceList: "",
          pinCode: "",
          roomType: "",
          defineOrSelectExistingToilet: "",
          createButtonClicked: "",
          existingToiletName: "",
          newToiletName: "",
          newlyAddedToiletNodeID: "",
          toiletSeats: "",
          toiletSection: "",
          tankheight: "",
          volumeLitres: "",
          // clear backend/other errors
          others: "",               
        },
      }));
      return;
      
      // clear all the input error messages.
      case "deviceName":
        errors.deviceName = ""
      break;

      case "roomType":
        errors.roomType = "";
        // errors.others = "";
        setState({
          ...state,
          roomType: value,
          // errors
        });
      break;

      case "pinCode":
        // remove non-numeric
        let numericValue = value.replace(/\D/g, ""); 
        if (numericValue.length > 6) {
          // limit to 6 digits
          numericValue = numericValue.slice(0, 6); 
        }
        errors.pinCode = "";
        // errors.others = "";
        setState({
          ...state,
          pinCode: value,
          // errors
        });
      break;

      case "defineOrSelectExistingToilet":
        errors.defineOrSelectExistingToilet = value ? "" : "Toilet Selection is required";
        break;

      case "existingToiletName":
        errors.existingToiletName = "";
        break;

      case "newToiletName":
        errors.newToiletName = "";
        errors.newlyAddedToiletNodeID = ""; 
          setState(prev => ({
            ...prev,
            newToiletName: value,
            createButtonClicked: "",   // clear success message
            errors: {
              ...prev.errors,
              newToiletName: "",
              newlyAddedToiletNodeID: "",
              others: ""
            }
          }));
          return;
      break;

      case "newlyAddedToiletNodeID":
        errors.newlyAddedToiletNodeID = "";
      break;

      case "toiletSeats":
      errors.toiletSeats = "";
      break;

      case "volumeLitres":
      errors.volumeLitres = "";
      break;

      case "tankheight":
      errors.tankheight = "";
      break;

      case "toiletSection":
      errors.toiletSection = "";
      break;

    }
    setState((prev) => ({
      ...prev,
      [name]: value,
      createButtonClicked: "", 
      errors: {
        ...prev.errors,
        ...errors,
        others: "", // clear generic errors too
      },
      // This handles the dependent field updates triggers action based on the selected toilet section type.
      ...(name === "defineOrSelectExistingToilet" && value === "NEW"
        ? { arrExistingToiletList: [], existingToiletName: "" }
        : {}),
    }));

    if (name === "defineOrSelectExistingToilet" && value === "EXISTING") {
      selectExistingToiletName({ ...state, defineOrSelectExistingToilet: value });
    }
  };

  // Gives names of the toiled nodes present for that particular email id(user) .
  const selectExistingToiletName = (inModifiedState = null) => {
    let modifiedState = inModifiedState == null ? { ...state } : { ...inModifiedState };
    
    let loggedInUserFromDeviceTree = modifiedState.email?.toLowerCase() || "";

    let jsonParams = {
      LoggedInUserFromDeviceTree: loggedInUserFromDeviceTree,
      InvokedFrom: "deviceTree"
    }

    axios.post(`${getAPIHostURL()}/wclient/getTreeInfo`, jsonParams)
    .then(response => {
      if(response.data.code == 'SUCCESS') {
        const list = response.data.retreivedTreeNodeIDNameAndDesc;
        if (Array.isArray(list) && list.length > 0) {
        // Map backend data to the format that dropdown expects.
          modifiedState.arrExistingToiletList = list
          .filter(item => item.ParentNodeDispName && item.ParentNodeDispName.trim().length > 0)
          .map(item => ({
            NodeId: item.NodeId,
            ParentNodeDispName: item.ParentNodeDispName
          }));
          // Optionally, set the first item as the selected value
          // modifiedState.existingToiletName = modifiedState.arrExistingToiletList[0].NodeId;
          modifiedState.existingToiletName = "";
        } else {
          modifiedState.arrExistingToiletList = [];
          modifiedState.existingToiletName = "";
        }

        modifiedState.errors.others = "";
        setState(prev => ({
          ...prev,
          arrExistingToiletList: modifiedState.arrExistingToiletList,
          existingToiletName: modifiedState.existingToiletName,
          errors: {
            ...prev.errors,
            others: ""
          }
        }));
        // setState(modifiedState);
      } else {
          if (response.data.code == 'REQ_PARAMS_MISSING') {
              modifiedState.errors.others = "Server experiencing issues (required parameters not sent). Try again later."; // TODO: 
          } else if(response.data.code == "SQL_ERROR") {
              modifiedState.errors.others = "Server experiencing issues.\nTry again later.";  
          } else if(response.data.code == "INVALID_DEVICEID") {
              modifiedState.errors.others = response.data.failuremessage;  
          } else {
              console.log("Should not reach here.")
              modifiedState.errors.others = "Server experiencing issues.\nTry again later.";   
          }
          alert(modifiedState.errors.others);
        }   
        // setState(modifiedState);  
        setState(prev => ({
          ...prev,
          errors: {
            ...prev.errors,
            others: modifiedState.errors.others
          }
        }));
    }) .catch( error => {

      if (axios.isCancel(error)) {
          console.log('Axios request cancelled beacuse of too many requests being sent to the Server.');
      } else {
          setState(prev => ({
          ...prev,
          errors: {...prev.errors, others: "Network error. Please try again."
          }
        }));
      }
    });
  }
  // column where user gives name to a new toiled node where devices are now stored.
  const handleNewToiletName = () => {
    if (state.newToiletName && state.newToiletName.trim().length > 0) {
      
      setState(prev => ({
        ...prev,
        definedNewToiletName: prev.newToiletName,
        addedToiletName: prev.newToiletName,  
        errors: {
          ...prev.errors,
          newToiletName: "",
          newlyAddedToiletNodeID: "",
        }
      }));

      createNewToiletNode(state.newToiletName); 
    } 
  };

  const createNewToiletNode = (newToiletName, inModifiedState = null) =>{
    let modifiedState = inModifiedState == null ? { ...state } : { ...inModifiedState };
    if (!newToiletName || newToiletName.trim().length === 0) {
      modifiedState.errors = {
        ...modifiedState.errors,
        others: "Please enter a valid toilet name."
      };

      setState(modifiedState);
      return;
    }
    let loggedInUserFromDeviceTree = modifiedState.email?.toLowerCase() || "";
    let objForJsonNodeData = {
      HasDevices: true,
      DisplayName: newToiletName
    };

    let encodedObjForJsonNodeData = JSON.stringify(objForJsonNodeData);

    let jsonParams = {
      selectedNodeID: null,
      nodedata: encodedObjForJsonNodeData,
      loggedInUserID: loggedInUserFromDeviceTree,
      formViewMode: "AddNewToilet"
    };
    axios.post(`${getAPIHostURL()}/wclient/addEditRmvNodeOfTree`, jsonParams)
    .then((response) => {
      if (response.data.code === "SUCCESS") {

        // checks if the response gets the new toilet ID as expected.
        if (response.data.retrivedLatestTreeNodeID && response.data.retrivedLatestTreeNodeID.length > 0) {
          modifiedState.newlyAddedToiletNodeID = response.data.retrivedLatestTreeNodeID[0][0]['mostRecentTreeID'];
        }
        if (modifiedState.newlyAddedToiletNodeID) {
          modifiedState.newToiletSection = newToiletName;
          modifiedState.defineNewToiletName = "";
          modifiedState.errors.others = "";

          // setState(modifiedState);
          setState(prev => ({
            ...prev,
            newlyAddedToiletNodeID: modifiedState.newlyAddedToiletNodeID,
            createButtonClicked: "Premise created successfully",
            // clear errors
            errors: {
              ...prev.errors,
              newToiletName: "",
              newlyAddedToiletNodeID: "",
              others: ""
            }
          }));
          selectExistingToiletName({
            ...state,
            newlyAddedToiletNodeID: modifiedState.newlyAddedToiletNodeID
          });
        }

      } else {

        if (response.data.code === 'REQ_PARAMS_MISSING') {
          modifiedState.errors.others = "Server experiencing issues (required parameters not sent). Try again later.";
        } else if (response.data.code === "SQL_ERROR") {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        } else {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        }

        alert(modifiedState.errors.others);
        setState(modifiedState);
      }

    }) .catch(error => {
      if (axios.isCancel(error)) {
        console.log('Request cancelled.');
      } else {
        setState(prev => ({
          ...prev,
          errors: {
            ...prev.errors,
            others: "Network error. Please try again."
          }
        }));
      }
    });
  }

  // This object gives the user friendly messages for the backend errors appeared.
  const DEVICE_ERROR_MESSAGES = {
    DEVICE_NOT_REGISTERED: "Not Registered Devices",
    DEVICE_INVALID: "Invalid Device ID's",
    DEVICE_CURRENT_STATE_INVALID: "Invalid Device State ID's",
    NO_REGISTRATION_REQUIRED: "No Registration Required Devices",
    OWNERID_CANNOT_BE_MODIFIED: "Devices Owner Cannot Be Changed",
    OWNERID_ALREADY_EXISTS: "Devices Already Assigned to Another Owner",
    EMAIL_VALIDATION_REQUIRED: "Email Verification Required"
  };

  const deviceRegister = (e) => {
    e.preventDefault();

    let modifiedState = { ...state };
    modifiedState.errors = {
      email: "",
      arrDeviceList: "",
      pinCode: "",
      roomType: "",
      existingToiletName: "",
      defineOrSelectExistingToilet: "",
      newToiletName: "",
      toiletSection: "",
      toiletSeats: "",
      volumeLitres: "",
      newlyAddedToiletNodeID: "",
      tankheight: "",
      others: ""
    };
    // Validate all the input fields in the form.
    modifiedState.errors.email = !modifiedState.email
      ? "Email ID is Required."
      : !validEmailRegex.test(modifiedState.email)
        ? "Email ID is not valid!"
        : "";

    modifiedState.errors.arrDeviceList =
      !modifiedState.arrDeviceList || modifiedState.arrDeviceList.length === 0
        ? "Add a Device"
        : "";

    if (!modifiedState.pinCode) {
      modifiedState.errors.pinCode = "Pincode is Required.";
    } else if (!/^\d{6}$/.test(modifiedState.pinCode)) {
      modifiedState.errors.pinCode = "Pincode must be exactly 6 digits.";
    }
   
    modifiedState.errors.roomType =
      !modifiedState.roomType || modifiedState.roomType.trim() === ""
        ? "Room type is Required."
        : "";
    
    modifiedState.errors.defineOrSelectExistingToilet = !modifiedState.defineOrSelectExistingToilet
        ? "System Selection is Required"
        : "";
    if (modifiedState.defineOrSelectExistingToilet === "EXISTING") {
      modifiedState.errors.existingToiletName = !modifiedState.existingToiletName
        ? "Existing Name is Required."
        : "";
    }
    if (modifiedState.defineOrSelectExistingToilet === "NEW") {

      if (!modifiedState.newToiletName || modifiedState.newToiletName.trim() === "") {
        modifiedState.errors.newToiletName = "New name is Required";
        modifiedState.errors.newlyAddedToiletNodeID = ""; // clearing other error
      } 
      else if (!modifiedState.newlyAddedToiletNodeID) {
        modifiedState.errors.newToiletName = ""; // clearing first error
        modifiedState.errors.newlyAddedToiletNodeID = "Click create button to create premise";
      }

    }
    if (modifiedState.retrivedDeviceType === "PFC") {
      modifiedState.errors.toiletSection = !modifiedState.toiletSection || modifiedState.toiletSection.trim() === ""
          ? "Toilet Section is Required"
          : "";
      modifiedState.errors.toiletSeats = !modifiedState.toiletSeats || isNaN(modifiedState.toiletSeats) || Number(modifiedState.toiletSeats) <= 0
          ? "Enter a valid number of toilet seats"
          : "";
    }
    if (modifiedState.retrivedDeviceType === "WLI") {
      modifiedState.errors.volumeLitres = !modifiedState.volumeLitres || isNaN(modifiedState.volumeLitres) || Number(modifiedState.volumeLitres) <= 0
        ? "Enter tank volume in litres"
        : "";
    }
    if (["WLI", "STLI"].includes(modifiedState.retrivedDeviceType)) {
      modifiedState.errors.tankheight = !modifiedState.tankheight || isNaN(modifiedState.tankheight) || Number(modifiedState.tankheight) <= 0
        ? "Enter tank height in centimeters"
        : "";
    }

    const hasErrors = Object.values(modifiedState.errors).some(
      (err) => typeof err === "string" && err.length > 0
    );
  
    if (hasErrors) {
      setState({ ...modifiedState }); // show errors in UI
      return; 
    }
    
    // if no errors, show confirmation
    const confirmRegister = window.confirm("Do you want to register this device?");
    if (!confirmRegister) {
      alert("Device registration cancelled.");
      return;
    }

    //  Proceed with API call
    let jsonParams = {
      ownerID: modifiedState.email?.toLowerCase(),
      DeviceID: modifiedState.arrDeviceList.map((device) => ({
        DeviceID: device.id,
        DeviceName: device.name,
        // DeviceType: modifiedState.retrivedDeviceType,
      })),
      pincode: modifiedState.pinCode,
      IsDeviceInstalled: modifiedState.isDeviceInstalled,
      installVicinityID: modifiedState.roomType,
      ToiletID: modifiedState.defineOrSelectExistingToilet == "EXISTING" ? modifiedState.existingToiletName
        : modifiedState.defineOrSelectExistingToilet == "NEW"
        ? modifiedState.newlyAddedToiletNodeID
        : "",
      SeatsInToilet: modifiedState.toiletSeats == null || modifiedState.toiletSeats.length <= 0 
        ? ""
        : modifiedState.toiletSeats,

      ToiletSection: modifiedState.toiletSection == null || modifiedState.toiletSection.length <= 0 
        ? ""
        : modifiedState.toiletSection,

      TankVolume : modifiedState.volumeLitres == null || modifiedState.volumeLitres.length <= 0 
        ? ""
        : modifiedState.volumeLitres,

      TankDist : modifiedState.tankheight == null || modifiedState.tankheight.length <= 0 
        ? ""
        : modifiedState.tankheight,
    };
    axios.post(`${getAPIHostURL()}/wclient/registerBulkDevices`, jsonParams)
    .then((response) => {
      if (response.data.code === "SUCCESS") {

        if(response.data.DevicesStatusRes == null ||response.data.DevicesStatusRes.length <= 0 ) {
                          modifiedState.showRegisterSummaryBox = false;

          alert("The Registration is successful");
        } else {
            const backendErrors = response.data.DevicesStatusRes || [];
            // Some devices failed from backend are listed below.
            if (backendErrors.length > 0) {
                modifiedState.showRegisterSummaryBox = true;

                modifiedState.groupedErrors = {};

                backendErrors.forEach(group => {
                  // Extract backend error code and map it to user-friendly message.
                  const reason = group.reason;
                  const readableMessage = DEVICE_ERROR_MESSAGES[reason] || reason;

                  // Initialize array for this error message if not already present.
                  if (!modifiedState.groupedErrors[readableMessage]) {
                    modifiedState.groupedErrors[readableMessage] = [];
                  }
                  // Add all device IDs under the corresponding error message.
                  group.devices.forEach(deviceID => {
                    modifiedState.groupedErrors[readableMessage].push(deviceID);
                  });
                });
            }
          }
          // keep email verification state
          modifiedState.email = "";
          modifiedState.isEmailVerified = false; 

          // show summary
          modifiedState.failedDevices =  modifiedState.groupedErrors;

          // RESET EVERYTHING ELSE
          modifiedState.deviceID =  "";
          modifiedState.deviceName =  "";
          modifiedState.arrDeviceList =  [];
          modifiedState.pinCode =  "";

          modifiedState.roomType =  "";
          modifiedState.toiletSection =  "";
          modifiedState.toiletSeats =  "";
          modifiedState.volumeLitres =  "";
          modifiedState.tankheight =  "";
          modifiedState.defineOrSelectExistingToilet =  "";
          modifiedState.existingToiletName =  "";
          modifiedState.newToiletName =  "";
          modifiedState.newlyAddedToiletNodeID =  "";

          // reset errors
          modifiedState.errors = {
            email: "",
            arrDeviceList: "",
            pinCode: "",
            roomType: "",
            existingToiletName: "",
            defineOrSelectExistingToilet: "",
            newToiletName: "",
            toiletSection: "",
            toiletSeats: "",
            volumeLitres: "",
            newlyAddedToiletNodeID: "",
            tankheight: "",
            others: ""
          
        };
      } else {
        if (response.data.code === "SQL_ERROR") {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        } else if (response.data.code == 'REQ_PARAMS_MISSING') {
            modifiedState.errors.others = 'Server experiencing issues (required parameters not sent). Try again later.';
        } else {
          modifiedState.errors.others = "Server experiencing issues. Try again later.";
        }
      }
      setState(modifiedState);
    })
    .catch((error) => {
        setState((prev) => ({
          ...prev,
          errors: { ...prev.errors, others: "Network error. Please try again." },
        }));
    });
  };

  return (
    <div>
      <div className="deviceRegistrationPage">
        <div className="modal-body addCustbox">
          <div
            className="headingForComponentsOfCrmPage"
            style={{
              marginBottom: "0.8rem",
              display: "block",
              alignSelf: "center",
            }}
          >
            Device Registration
          </div>
          <form>
            {state.isEmailVerified &&(
              <label
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  fontSize: "0.7rem",
                }}
              >
                <b style={{ marginRight: "0.1rem" }}>Note: </b> Fields marked in{" "}
                <span
                  style={{
                    color: "var(--errorColor)",
                    fontSize: "1rem",
                    marginLeft: "0.1rem",
                    marginRight: "0.1rem",
                  }}
                >
                  *{" "}
                </span>{" "}
                are compulsory.
              </label>
            )}
            {state.showRegisterSummaryBox && (
              <div className="deviceGroupBox" style={{ marginBottom: "10px" , position: "relative" }}>
                <FaTimes
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "10px",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#666"
                  }}
                  title="Close"
                  onClick={() =>
                    setState(prev => ({
                      ...prev,
                      showRegisterSummaryBox: false,
                      failedDevices: []
                    }))
                  }
                />
                <div className="addCustError" style={{ marginBottom: "8px", fontWeight: "bold", color: "#666666" }}>
                  Some devices could not be registered. Please review the issues below.
                </div>
                
                <div className="form-group addCustForm">
                  <div className="inputgroupCustom ">

                    <label className="addCustFormLabelWithoutRequiredFiledDeviceRegister">
                      Failed Devices:
                    </label>

                    <div className="addCustInputAndErrorDeviceRegister">
                      {Object.keys(state.failedDevices).length > 0 && Object.entries(state.failedDevices).map(([reason, deviceIds], index) => (
                        <div className="deviceListRow" key={index}>
                          {/* ERROR MESSAGE (REASON) ONLY */}
                          <span className="addCustErrorForTop">
                            {reason}
                          </span>

                          {/* VIEW ALL */}
                          <span
                            className="viewAllText"
                            onClick={() => {
                              setSelectedFailedGroup({ reason, deviceIds });
                              setShowFailedDeviceModal(true);
                            }}
                            style={{
                              cursor: "pointer",
                              color: "var(--primaryColor)",
                              fontWeight: "600",
                              textDecoration: "underline",
                              // marginLeft: "10px"
                              marginRight: "200px"
                            }}
                          > 
                          View
                          </span>

                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "10px",
                    fontSize: "0.70rem",
                    color: "#666",
                    // color: "green",
                    textAlign: "left",
                    width: "100%"  

                  }}
                >
                  <b>Note:</b> This list of failed devices will be removed once the email is verified again.
                </div>
              </div>
            )}
            {/* ============= Topmost box modal error display ================ */}
            <Modal
                isOpen={showFailedDeviceModal}
                toggle={() => setShowFailedDeviceModal(false)}
                centered
              >
                <ModalHeader toggle={() => setShowFailedDeviceModal(false)}>
                  Failed Devices
                </ModalHeader>

                <ModalBody>
                  {selectedFailedGroup && (
                    <>
                      <div className="deviceListBox modalDeviceScroll">
                        {selectedFailedGroup.deviceIds.map((id, index) => (
                          <div key={index} className="deviceListRow">
                            <span className="deviceText">{id}</span>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </ModalBody>
            </Modal>
            <div className="form-group addCustForm">
              <div style={{ paddingLeft: "8px" }} className="inputgroupCustom">
                <label className="addCustFormLabelWithRequiredFiledDeviceRegister">
                  Email ID:<span className="addCustRequiredMarkStarDeviceRegister">*</span>
                </label>
                <div className="addCustInputAndErrorDeviceRegister">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="email"
                      name="email"
                      className="addCustInputForm"
                      required
                      value={state.email.toLocaleLowerCase()}
                      onChange={handleChange}
                      noValidate
                      style={{ flex: 1 }} // input takes remaining width
                    />
                    {/* Show Verify button ONLY if email is NOT verified */}
                    {!state.isEmailVerified && (
                      <button
                        type="button"
                        onClick={verifyEmail}
                        style={{
                          marginLeft: "8px",
                          textTransform: "capitalize",
                          fontWeight: "bold",
                          fontSize: "0.9rem",
                        }}
                        className="addDeviceBtnInline"
                      >
                        Verify
                      </button>
                    )}
                  </div>
                  {errors.email.length > 0 && (
                    <span className="addCustError">{errors.email}</span>
                  )}
                  {!state.isEmailVerified && state.errors.others.length > 0 && (
                    <div className="form-error-message">{state.errors.others}</div>
                  )}
                </div>
              </div>
            </div>
            {state.isEmailVerified && !state.showRegisterSummaryBox && (
              <>
                <div className="deviceGroupBox">
                  {/* Device ID / QR Scan */}
                  <div className="form-group addCustForm">
                    <div className="inputgroupCustom">
                      <label className="addCustFormLabelWithRequiredFiledDeviceRegister">
                        Scan / Enter Device ID:
                        <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                      </label>

                      <div className="addCustInputAndErrorDeviceRegister">
                        <div className="inputWithIcon">
                          <input
                            type="text"
                            name="deviceID"
                            className="addCustInputForm"
                            value={state.deviceID}
                            required = "required"
                            onChange={onChangedeviceID}
                            // onKeyDown={handleKeyDown}
                            placeholder="Scan or enter Device ID"
                          />
                          <FaQrcode
                            className="inputIcon"
                            onClick={openQRCameraForPrdItmStateDevcID}
                            title="Scan QR"
                          />
                        </div>
                          {state.devcIDQRCodeFlag && (
                            <div className="qrScannerWrapper">
                              <QrScanner
                                onDecode={(result) => {
                                  handleScanResultOfPrdItmStateDevcID(result);
                                }}
                                onError={(error) => console.error(error)}
                                constraints={{ facingMode: "environment" }}
                              />
                            </div>
                          )}
                          {errors.deviceID && (
                          <span className="addCustError">{errors.deviceID}</span> //frontend error
                          )}
                          {errors.deviceExistenceErr && (
                          <span className="addCustError">{errors.deviceExistenceErr}</span> //backend error
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="form-group addCustForm">
                    <div className="inputgroupCustom">
                      <label className="addCustFormLabelWithRequiredFiledDeviceRegister">
                        Device Name:
                        <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                      </label>
                      <div className="addCustInputAndErrorDeviceRegister">
                        <div className="inlineInputWithBtn">
                          <input
                            type="text"
                            name="deviceName"
                            className="addCustInputForm"
                            required = "required"
                            value={state.deviceName}
                            onChange={handleChange}
                          />
                        <button
                            type="button"
                            className="addDeviceBtnInline"
                            // onClick={validateDeviceTypeAndState}
                            onClick={validateDeviceTypeAndState}
                          >
                            Add
                          </button>
                        </div>
                        {errors.deviceName && (
                          <span className="addCustError">{errors.deviceName}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-group addCustForm">
                    <div className="inputgroupCustom">
                      <label className="addCustFormLabelWithoutRequiredFiledDeviceRegister">
                        Added Devices:
                      </label>
                      <div className="addCustInputAndErrorDeviceRegister">
                        <div className="deviceListBox">
                          {state.arrDeviceList?.length <= 0 && (
                            <div className="deviceEmptyText">No device added</div>
                          )}
                          {state.arrDeviceList?.length> 0 && state.arrDeviceList.map((device) => (                          
                            <div className="deviceListRow" key={device.id}>
                              <span className="deviceText">
                              <strong>{device.id} - {device.name}</strong> 
                              </span>
                              <FaTimes
                                className="deleteDeviceIcon"
                                title="Remove"
                                onClick={() => removeDevice(device.id)}
                              />
                            </div>                          
                          ))}
                        </div>
                        {errors.arrDeviceList && (
                          <span className="addCustError">{errors.arrDeviceList}</span>
                          )}
                        {state.errors.others.length > 0 && (
                    <div className="form-error-message">{state.errors.others}</div>
                    )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group addCustForm">
                  <div className="inputgroupCustom">

                    <label className="addCustFormLabelWithoutRequiredFiledDeviceRegister deviceInstallLabel">
                      Device Installation Status:
                    </label>

                    <div className="addCustInputAndErrorDeviceRegister">

                      <div
                        className={`deviceInstallCard ${
                          state.isDeviceInstalled ? "installedActive" : "notInstalledActive"
                        }`}
                      >
                        <span className="deviceInstallText">
                          {state.isDeviceInstalled ? "Installed" : "Not Installed"}
                        </span>

                        <label className="customToggleSwitch">
                          <input
                            type="checkbox"
                            checked={state.isDeviceInstalled}
                            onChange={(e) =>
                              setState((prev) => ({
                                ...prev,
                                isDeviceInstalled: e.target.checked,
                              }))
                            }
                          />
                          <span className="toggleSlider"></span>
                        </label>
                      </div>

                    </div>
                  </div>
                </div>
                <div className="form-group addCustForm">
                  <div  className="inputgroupCustom">
                    <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                      Installed Location Pincode:<span className="addCustRequiredMarkStarDeviceRegister">*</span>
                    </label>

                    <div className="addCustInputAndErrorDeviceRegister">
                      <input
                        type="text"
                        name="pinCode"
                        className="addCustInputForm"
                        required = "required"
                        maxLength={6}
                        value={state.pinCode}
                        onChange={handleChange}
                      />
                      {errors.pinCode && (
                        <span className="addCustError">{errors.pinCode}</span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="form-group addCustForm">
                  <div className="inputgroupCustom">
                    <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                      Room Type:
                      <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                    </label>
                    <div className="addCustInputAndErrorDeviceRegister">
                      <select
                        name="roomType"
                        className="addCustInputForm"
                        required = "required"
                        value={state.roomType}
                        onChange={handleChange}
                      >
                        <option value="">Select...</option>
                        {state.roomTypes.map((type, index) => (
                        <option key={index} value={type}>{type}</option>
                        ))}
                      </select>
                      {errors.roomType && (
                        <span className="addCustError">{errors.roomType}</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* ============================================================================== */}
                <div className="form-group addCustForm" style={{ display: state.retrivedDeviceType == "PFC" ? "block" : "none" }}>
                    <div className="inputgroupCustom">
                      <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                        Toilet Section:
                        <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                      </label>
                      <div className="addCustInputAndErrorDeviceRegister">
                        <div className="inlineInputWithBtn">
                          <select
                          type="text"
                            name="toiletSection"
                            className="addCustInputForm"
                            value={state.toiletSection}
                            onChange={handleChange}
                            >
                            <option value="">Select...</option>
                            <option value="Men">Men</option>
                            <option value="Women">Women</option>
                          </select>
                        </div>
                        {errors.toiletSection && (
                          <span className="addCustError">{errors.toiletSection}</span>
                        )}
                      </div>
                    </div>
                </div>
                <div className="form-group addCustForm"
                  style={{ display: state.retrivedDeviceType == "PFC" ? "block" : "none" }}
                  >
                  <div className="inputgroupCustom">
                    <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                      No. of Toilet Seats:
                      <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                    </label>
                    <div className="addCustInputAndErrorDeviceRegister">
                      <div className="inlineInputWithBtn">
                        <input
                          type="text"
                          name="toiletSeats"
                          className="addCustInputForm"
                          value={state.toiletSeats}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.toiletSeats && (
                        <span className="addCustError">{errors.toiletSeats}</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* ============================================================================ */}
                <div className="form-group addCustForm" style={{ display: state.retrivedDeviceType == "WLI" ? "block" : "none" }}>
                  <div className="inputgroupCustom">
                    <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                      Tank Volume(Litre):
                      <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                    </label>
                    <div className="addCustInputAndErrorDeviceRegister">
                      <div className="inlineInputWithBtn">
                        <input
                          type="text"
                          name="volumeLitres"
                          className="addCustInputForm"
                          value={state.volumeLitres}
                          onChange={handleChange}
                        />
                      </div>
                      {errors.volumeLitres && (
                        <span className="addCustError">{errors.volumeLitres}</span>
                      )}
                    </div>
                  </div>
                </div>
                {/* ============================================================================ */}
                <div className="form-group addCustForm" style={{ display: state.retrivedDeviceType === "WLI" || state.retrivedDeviceType ==="STLI" ? "block" : "none" }}>
                    <div className="inputgroupCustom">
                      <label className="addCustFormLabelWithRequiredFiledDeviceRegister" style={{marginRight: "8px"}}>
                        Tank Height(centimeter):
                        <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                      </label>
                      <div className="addCustInputAndErrorDeviceRegister">
                        <div className="inlineInputWithBtn">
                          <input
                            type="text"
                            name="tankheight"
                            className="addCustInputForm"
                            value={state.tankheight}
                            onChange={handleChange}
                          />
                        </div>
                        {errors.tankheight && (
                          <span className="addCustError">{errors.tankheight}</span>
                        )}
                      </div>
                    </div>
                </div>
                {/* ====================================================================================== */}
              <div className="form-group addCustForm">
                <div  style={{lineHeight:"1.3rem",whiteSpace:"normal"}} className="inputgroupCustom">
                  <label  className="addCustFormLabelWithRequiredFiledDeviceRegister">
                  Define New or Select Existing Premises:
                  <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                </label>
                  <div style={{marginLeft: "8px"}} className="addCustInputAndErrorDeviceRegister">
                    <select
                      name="defineOrSelectExistingToilet"
                      className="addCustInputForm"
                      value={state.defineOrSelectExistingToilet}
                      onChange={handleChange}
                    >
                      <option value="">Select...</option>
                      <option value="EXISTING">Select Existing Premises</option>
                      <option value="NEW">Define New Premises</option>
                      <option value="NA">NA</option>
                    </select>
                    {errors.defineOrSelectExistingToilet && (
                      <span className="addCustError">{errors.defineOrSelectExistingToilet}</span>
                    )}
                  </div>
                </div>
            </div>
            {state.defineOrSelectExistingToilet === "EXISTING" &&(
              <div className="form-group addCustForm">
                <div style={{lineHeight:"1.3rem",whiteSpace:"normal"}} className="inputgroupCustom">
                  <label 
                  
                  className="addCustFormLabelWithRequiredFiledDeviceRegister">
                    Select Existing Premise Name:
                    <span  className="addCustRequiredMarkStarDeviceRegister">*</span>
                  </label>
                  <div style={{marginLeft: "8px"}} className="addCustInputAndErrorDeviceRegister">
                    <select
                      name="existingToiletName"
                      className="addCustInputForm"
                      required = "required"
                      value={state.existingToiletName}
                      onChange={handleChange}
                    >
                      <option value="">Select...</option>
                      {/* mapped API systems here */}
                      {state.arrExistingToiletList.map((toilet) => (
                        <option key={toilet.NodeId} value={toilet.NodeId}>
                          {toilet.ParentNodeDispName}
                          </option>
                        ))}
                    </select>
                    {!state.email && (
                      <span className="addCustError">Email ID is required to select an existing system</span>
                      )}
                      {state.email && !validEmailRegex.test(state.email) && (
                        <span className="addCustError">Enter a valid email to select an existing system</span>
                        )}

                    {errors.existingToiletName && (
                      <span className="addCustError">{errors.existingToiletName}</span>
                    )}
                  </div>
                </div>
              </div>
            )}
            {/* ============================= */}
            {state.defineOrSelectExistingToilet === "NEW" && (
              <div className="form-group addCustForm">
                <div className="inputgroupCustom">
                  <label
                    style={{
                      display: "flex",
                      alignContent: "center",
                    
                      marginRight: "7px",
                    }}
                    className="addCustFormLabelWithRequiredFiledDeviceRegister"
                  >
                    Define Premise Name:
                    <span className="addCustRequiredMarkStarDeviceRegister">*</span>
                  </label>
                  <div className="addCustInputAndErrorDeviceRegister">
                    <div className="inlineInputWithBtn">
                      <input
                        type="text"
                        name="newToiletName"
                        className="addCustInputForm"
                        value={state.newToiletName}
                        onChange={handleChange}
                        placeholder="Enter new toilet name"
                      />
                      <button
                        type="button"
                        className="addDeviceBtnInline"
                        onClick={handleNewToiletName} 
                        disabled={!!state.createButtonClicked}

                      >
                        Create
                      </button>
                    </div>
                    {errors.newToiletName && (
                      <span className="addCustError">{errors.newToiletName}</span>
                    )}
                    {errors.newlyAddedToiletNodeID && (
                    <span className="addCustError">{errors.newlyAddedToiletNodeID}</span>
                  )}
                  {state.createButtonClicked && (
                    <span
                      style={{
                        color: "green",
                        fontSize: "0.8rem",
                        marginTop: "4px",
                        display: "block"
                      }}
                    >
                      {state.createButtonClicked}
                    </span>
                  )}
                  </div>
                </div>
              </div>
            )}
              <div className="form-group addCustForm registerBtnWrapper">
                  <button
                    type="submit"
                    className="addCustSubmitBtn"
                    onClick={deviceRegister}
                  >
                    Register
                  </button>
              </div>
              </>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
export default VcDeviceRegistration;
